import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
export default function MobileModal(props) {
    const { side = 'left', isOpen, setIsOpen, children } = props;
    const modalRef = useRef(null);
    const [isAnimating, setIsAnimating] = useState(false);
    useEffect(() => {
        if (isOpen) {
            setIsAnimating(true);
            document.body.classList.add('cio-mobile-modal-backdrop-no-scroll');
        }
        else {
            document.body.classList.remove('cio-mobile-modal-backdrop-no-scroll');
        }
    }, [isOpen]);
    const onClose = () => {
        setIsAnimating(false);
        modalRef.current
            ?.querySelector('.cio-mobile-modal-wrapper')
            ?.addEventListener('transitionend', () => {
            setIsOpen(false);
        });
    };
    if (!isOpen) {
        return null;
    }
    return (React.createElement("aside", { ref: modalRef, className: classNames(`cio-mobile-modal-container cio-mobile-only cio-mobile-modal-${side}`, {
            'cio-mobile-modal-open': isAnimating,
        }) },
        React.createElement("div", { className: 'cio-mobile-modal-backdrop', role: 'presentation', onClick: onClose }),
        React.createElement("div", { className: 'cio-mobile-modal-wrapper' },
            React.createElement("div", { className: 'cio-mobile-modal-content' }, children))));
}
